import { render } from "./no-layout.vue?vue&type=template&id=07755693&ts=true"
import script from "./no-layout.vue?vue&type=script&lang=ts"
export * from "./no-layout.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__